import {Box} from "@mui/material";
import {ScaleLoader} from "react-spinners";

const Loading = () => {
    return (
        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh'}}>
            <ScaleLoader
                color={'#0c7f8b'}
                loading={true}
                aria-label="Loading"
            />
        </Box>
    )
}

export default Loading;
